<template>
    <div class="dialog" :class="{ 'active' : isVisible }">
        <div class="dialog--content" :class="'dialog--content-' + type">
            <template v-if="title">
                <h2>{{ title }}</h2>
            </template>
            <template v-if="message">
                <p v-html="message">{{ message }}</p>
            </template>
            <p v-if="showActionButtons" class="text-center">
                <button class="button" @click="onClickAction('yes')">{{ $t('yes') }}</button>
                <button class="button gray" @click="onClickAction('no')">{{ $t('no') }}</button>
            </p>
            <button class="close-button" @click="onClickAction('close')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : ''
            },
            autoCloseTimeout : {
                type : Number,
                default : 3000
            },
            showActionButtons : {
                type : Boolean,
                default : false
            },
            type : {
                type : String,
                default : ''
            },
            title : {
                type : String,
                default : ''
            },
            message : {
                type : String,
                default : ''
            }
        },
        data : function () {
            return {
                timeout     : null,
                isVisible   : false
            };
        },
        watch : {
            message : function (newVal, oldVal) {
                if (newVal !== null) {
                    this.onOpenDialog();
                }
            }
        },
        methods : {
            onOpenDialog : function () {
                this.isVisible = true;

                if (parseInt(this.autoCloseTimeout) > 0) {
                    this.timeout = setTimeout((function () {
                        if (this.isVisible) {
                            this.onCloseDialog();
                        }
                    }).bind(this), this.autoCloseTimeout);
                }
            },
            onCloseDialog : function () {
                this.isVisible = false;

                clearTimeout(this.timeout);
            },
            onClickAction : function (action) {
                this.onCloseDialog();

                this.$emit('onClickAction', this.id, action);
            }
        }
    }
</script>